module.exports = __webpack_public_path__ + "images/quality_scales_diagram_f245dee.png";